import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.new.color.text.secondary,
    border: `1px solid ${theme.new.color.line.border}`,
    backgroundColor: 'transparent',
    height: '46px',
    width: '100%',
    padding: '8px 12px',
    minHeight: '38px',
    borderRadius: '8px',

    '&:hover': {
      backgroundColor: theme.new.color.brand[100],
    },

    '&.active': {
      backgroundColor: theme.new.color.brand[100],
    },
  },
  countBadge: {
    padding: '2px 8px',
    marginLeft: '8px',
    backgroundColor: theme.new.color.grey[600],
    color: theme.new.color.common.white,
    width: 'fit-content',
    borderRadius: '4px',
  },
}));

export default useStyles;
